import type { SchedulePrefillResponsible } from "@/api/schedule/models";
import { InputDropdown, InputRow, InputValue } from "@/components/common/inputs";
import type { FormControl } from "@/interfaces/form";

interface Props {
  control: FormControl;
  options: { label: string; value: string }[];
  responsible?: SchedulePrefillResponsible;
}

export function PhotoRenewalResponsibleSection({ control, options, responsible }: Readonly<Props>) {
  return (
    <section>
      <h2 className="mb-4 text-base font-medium text-title">Responsável pelo Talento</h2>
      <InputDropdown
        control={control}
        field="responsibleIndex"
        label="Responsável"
        options={options}
        noOptionSelectedText="Selecionar"
        className="mb-4"
      />
      <InputRow>
        <InputValue
          control={control}
          field="responsibleEmail"
          label="Email"
          value={responsible?.email ?? ""}
          disabled
        />
        <InputValue
          control={control}
          field="responsiblePhone"
          label="Telefone 1 (WhatsApp)"
          value={responsible?.phone ?? ""}
          disabled
        />
      </InputRow>
      <InputValue
        control={control}
        field="responsibleSecondaryPhone"
        label="Telefone 2"
        value={responsible?.secondaryPhone ?? ""}
        disabled
        className="mt-4"
      />
    </section>
  );
}
